// Types et requêtes des réclamations (vue agent) : liste filtrée, fiche avec historique et pièces.
import { CATEGORIES_RECLAMATION, type CategorieReclamation } from '@cc/contrats';
import { useQuery } from '@tanstack/react-query';
import { requete } from '../../api/client';

export interface Reclamation {
  id: string;
  numero: string;
  categorie: string;
  categorie_libelle: string;
  description: string;
  objet_lie: { type: string; id: string } | null;
  sensible: boolean;
  etat: string;
  echeance: string | null;
  reponse: string | null;
  repondue_le: string | null;
  cloturee_le: string | null;
  evaluation: { note: number; commentaire: string | null; le: string | null } | null;
  cree_le: string;
  demandeur: { usager_compte_id: string | null; nom: string | null };
  service: { id: string; nom: string } | null;
  affectee_appartenance_id: string | null;
  sensible_motif: string | null;
  en_retard: boolean;
}

export interface ReclamationDetail extends Reclamation {
  historique: { type: string; etat_avant: string | null; etat_apres: string; auteur_compte_id: string | null; horodatage: string | null; donnees: Record<string, unknown> }[];
  pieces: { id: string; titre: string; type_mime: string; taille: number }[];
}

export const LIBELLES_ETAT_RECLAMATION: Record<string, string> = {
  recue: 'Reçue',
  en_instruction: 'En instruction',
  repondue: 'Répondue',
  cloturee: 'Clôturée',
};

export const LIBELLES_EVENEMENT_RECLAMATION: Record<string, string> = {
  reception: 'Réception',
  affectation: 'Affectation',
  marquage_sensible: 'Marquage sensible',
  reponse: 'Réponse',
  cloture: 'Clôture',
  evaluation: 'Évaluation par l\'usager',
};

export const LIBELLES_OBJET_LIE: Record<string, string> = { dossier: 'Dossier', service: 'Service', rendez_vous: 'Rendez-vous' };

export function libelleCategorie(code: string): string {
  return CATEGORIES_RECLAMATION[code as CategorieReclamation] ?? code;
}

export interface FiltresReclamations {
  etat: string;
  sensible: string;
  en_retard: string;
  service: string;
}

export function useReclamations(f: FiltresReclamations) {
  return useQuery({
    queryKey: ['reclamations', 'liste', f],
    queryFn: ({ signal }) => requete<{ elements: Reclamation[] }>('/reclamations', { signal, parametres: { etat: f.etat, sensible: f.sensible, en_retard: f.en_retard, service: f.service } }).then((r) => r.elements),
    retry: false,
  });
}

export function useReclamation(id: string) {
  return useQuery({
    queryKey: ['reclamations', 'fiche', id],
    queryFn: ({ signal }) => requete<ReclamationDetail>(`/reclamations/${id}`, { signal }),
    retry: false,
  });
}
